module.exports = __webpack_public_path__ + "static/img/yingyin.a46bd47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yingyin.png
// module id = JC3E
// module chunks = 128